import { Flex, Link, useTheme } from "@aws-amplify/ui-react";

export function SignUpFooter() {
  const { tokens } = useTheme();

  return (
    <Flex justifyContent="center" padding={`0 0 ${tokens.space.medium}`}>
        {/* <a href="https://www.google.se"  target="_blank">Privacy Policy</a> & <a href="https://www.google.se"  target="_blank">Terms of Service</a> */}
      {/* <Link color={"#35A2EB"} onClick={"https://www.google.se"}>Reset your password</Link> */}
    </Flex>
  );
}
